import React from 'react';

const ToolsInfoSection = (props) => {
    const { firstIcon, secondIcon, tag, title, text, image } = props
    //lg:mb-32 md:mb-20 sm:mb-5 mb-5
    return (
        <div className=" lg:px-11 md:px-10 sm:px-7 px-7  relative h-full ">
            <div className="inline-flex items-center mb-5 w-fit gap-5 lg:pl-14 md:pl-14 sm:pl-20 pl-20 lg:pt-14 md:pt-10 sm:pt-5 pt-5">
                <img loading="lazy" src={firstIcon} className="lg:h-20 md:h-20 sm:h-14 h-14"></img>
                <img loading="lazy" src={secondIcon} className="lg:h-20 md:h-20 sm:h-14 h-14"></img>
            </div>
            <p className="lg:text-2xl md:text-xl sm:text-lg text-lg  lg:pl-14 md:pl-14 sm:pl-20 pl-20 lg:mt-10 md:mt-10 sm:mt-5 mt-5">{tag}</p>
            {title}
            {text}

            
        </div>
    );
}

export default ToolsInfoSection;